import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";



export class ProjectSelectComponent implements IController {
    selectedId: any;
    from: number;
    to: number;
    ngPlaceholder: any;
    excludeIds: any;
    isDisabled: any;
    isRequired: boolean;

    onChange: Function;

    private projectsRef: any;
    public selectedPlanProject: any;
    public selectedText: any;

    /* @ngInject */
    constructor(private $mdPanel, private $planningProjects) {
        this.projectsRef = this.$planningProjects();
    }

    $onInit() {
        this._setSelectedProjects();
    };

    $onChanges(changes) {
        if (
            (changes.to && !changes.to.isFirstChange()) ||
            (changes.from && !changes.from.isFirstChange()) ||
            (changes.selectedId && !changes.selectedId.isFirstChange())
        ) {
            this._setSelectedProjects();
        }
    };


    onShowPanel($event) {

        if (!!this.isDisabled) {
            return;
        }

        const panelPosition = this.$mdPanel.newPanelPosition()
            .relativeTo($event.target)
            .addPanelPosition(
                this.$mdPanel.xPosition.CENTER,
                this.$mdPanel.yPosition.BELOW // yPosition.BELOW
            );

        const panelAnimation = this.$mdPanel.newPanelAnimation()
            .openFrom($event)
            .duration(200)
            .closeTo('.bringoz-select-input')
            .withAnimation(this.$mdPanel.animation.FADE);

        const selectedIdRef = this.selectedId;
        const excludeIdsRef = this.excludeIds;

        const fromRef = this.from;
        const toRef = this.to;

        const config = {
            attachTo: angular.element(document.body),
            controllerAs: 'ctrl',
            position: panelPosition,
            animation: panelAnimation,
            targetEvent: $event,
            template: '<bringoz-select-filter-panel ' +
                'type="ctrl.typeRef" ' +
                'selected-id="ctrl.selectedIdsRef" ' +
                'panel-ref="ctrl.mdPanelRef" ' +
                'query-map="ctrl.queryMapRef" ' +
                'exclude-ids="ctrl.excludeIdsRef">' +
                '</bringoz-select-filter-panel>',
            controller: function () {
                this.typeRef = 'plan-project';
                this.selectedIdsRef = selectedIdRef;
                this.excludeIdsRef = excludeIdsRef;
                this.queryMapRef = {
                    from: fromRef,
                    to: toRef,
                }
            },
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true,
            zIndex: 80,
            onCloseSuccess: (panel, selectedId) => {
                if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
                    selectedId = selectedIdRef;
                }

                if (!selectedId) {
                    this.onChange({planProject: undefined, id: undefined});
                    panel.destroy();
                }
                else {
                  this.projectsRef.$asyncValues([selectedId])
                    .then((planProjects) => {
                      this.onChange({planProject: planProjects[0], id: selectedId});
                      panel.destroy();
                    });
                }

            }
        };

        this.$mdPanel.open(config);
    }

    onResetFilter() {
        this.onChange({planProject: undefined, id: undefined});
    }

    private _setSelectedProjects() {
        if (!!this.selectedId) {

            this.projectsRef.$asyncValues([this.selectedId])
                .then((planProject) => {
                    this.selectedPlanProject = _.orderBy(planProject, ['name'], ['asc'])[0];
                    this._setSelectedText()
                });

        } else {
            this.selectedPlanProject = undefined;
            this._setSelectedText()
        }
    }

    private _setSelectedText() {
        this.selectedText = _.get(this.selectedPlanProject, 'name', '');
    }

}

angular
    .module('bringoz.admin.planning')
    .component('projectSelect', {
        require: {
            form: '^form'
        },
        bindings: {
            selectedId: '<?',
            from: '<?',
            to: '<?',
            ngPlaceholder: '@?',
            excludeIds: '<?',
            isDisabled: '<?',
            isRequired: '<?',
            onChange: '&'
        },
        template: require('./project-select.html').default,
        controller: ProjectSelectComponent
    });

